// import React, { useEffect, useState, useRef } from "react";
// import TablePagination from "@mui/material/TablePagination";
// import { useSelector } from "react-redux";
// import {
//   Box,
//   Card,
//   Typography,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Button,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   Grid,
//   Alert,
// } from "@mui/material";
// import { useLocation } from "react-router-dom";
// import toast from "react-hot-toast";
// import { useAttendance } from "../context/AttendanceContext";
// import configService from "../services/config";
// import TextField from "@mui/material/TextField";
// import CloseIcon from "@mui/icons-material/Close";
// import CameraAltIcon from "@mui/icons-material/CameraAlt";
// import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
// import CapturePhotoIcon from "@mui/icons-material/PhotoCamera";
// import DeleteIcon from "@mui/icons-material/Delete";

// // ── Photo limits ──
// const MIN_PHOTOS = 1;
// const MAX_PHOTOS = 3;

// const Jobs = () => {
//   const location = useLocation();

//   const [pagination, setPagination] = useState({
//     total: 0,
//     per_page: 15,
//     current_page: 1,
//     last_page: 1,
//   });

//   const [tasks, setTasks] = useState([]);
//   const [timer, setTimer] = useState(0);
//   const [loading, setLoading] = useState(false);

//   const { company_id, userId } = useSelector((state) => state.globalVariables);
//   const { punchedIn } = useAttendance();

//   const [statusFilter, setStatusFilter] = useState("all");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [filterFromDate, setFilterFromDate] = useState("");
//   const [filterToDate, setFilterToDate] = useState("");

//   const [photoModalOpen, setPhotoModalOpen] = useState(false);
//   const [pendingTaskId, setPendingTaskId] = useState(null);
//   const [photos, setPhotos] = useState([]);
//   const [cameraOpen, setCameraOpen] = useState(false);
//   const [stream, setStream] = useState(null);
//   const [completing, setCompleting] = useState(false);

//   const videoRef = useRef(null);
//   const canvasRef = useRef(null);
//   const photosRef = useRef(photos);
//   useEffect(() => { photosRef.current = photos; }, [photos]);


//   // Geolocation helper 
//   const getGeolocation = () =>
//     new Promise((resolve) => {
//       if (!navigator.geolocation) return resolve({ latitude: null, longitude: null });
//       navigator.geolocation.getCurrentPosition(
//         (pos) => resolve({ latitude: pos.coords.latitude, longitude: pos.coords.longitude }),
//         () => resolve({ latitude: null, longitude: null })
//       );
//     });

//   // UI dropdown value → backend filter value
//   const mapStatusToFilter = (uiValue) => {
//     const map = {
//       all: "all",
//       new: "pending",   // DB: new
//       running: "current",  // DB: in_progress
//       hold: "hold",     // DB: hold
//       completed: "completed",
//     };
//     return map[uiValue] ?? "all";
//   };

//   // DB status → UI display label
//   const getDisplayStatus = (dbStatus) => {
//     const map = {
//       new: "New",
//       in_progress: "Running",
//       hold: "On Hold",
//       completed: "Completed",
//       cancelled: "Cancelled",
//     };
//     return map[dbStatus] ?? "New";
//   };

//   // DB status → color 
//   const getStatusColor = (dbStatus) => {
//     const map = {
//       new: "#42a5f5",
//       in_progress: "#42a5f5",
//       hold: "#f39c12",
//       completed: "#2ecc71",
//       cancelled: "#e74c3c",
//     };
//     return map[dbStatus] ?? "#42a5f5";
//   };

//   // Core fetch 
//   const activeJob = async (
//     page = 1,
//     perPage = 15,
//     toDate = "",
//     fromDate = "",
//     statusUi = "all"
//   ) => {
//     try {
//       setLoading(true);

//       const payload = {
//         company_id,
//         staff_id: userId,
//         filter: mapStatusToFilter(statusUi), // ✅ mapped before sending
//         page,
//         per_page: perPage,
//         // ✅ empty strings nahi bhejna — backend date validation fail karta hai
//         ...(fromDate ? { from_date: fromDate } : {}),
//         ...(toDate ? { to_date: toDate } : {}),
//       };

//       const response = await configService.getMyJobs(payload);

//       if (response.status) {
//         setTasks(response.data || []);
//         setPagination(response.pagination);
//       } else {
//         toast.error(response.message || "Failed to load tasks.");
//       }
//     } catch (error) {
//       console.error("Error fetching job details:", error);
//       toast.error("Failed to load tasks.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     activeJob();
//   }, []);

//   // Filter change → re-fetch
//   useEffect(() => {
//     activeJob(1, 15, filterToDate, filterFromDate, statusFilter);
//   }, [filterFromDate, filterToDate, statusFilter]);

//   // Pagination 
//   const handleChangePage = (event, newPage) => {
//     activeJob(newPage + 1, pagination.per_page, filterToDate, filterFromDate, statusFilter);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     const newPerPage = parseInt(event.target.value, 10);
//     activeJob(1, newPerPage, filterToDate, filterFromDate, statusFilter);
//   };

//   //  Timer 
//   useEffect(() => {
//     const interval = setInterval(() => {
//       const activeTask = tasks.find((t) => t.status === "in_progress");
//       if (activeTask?.actual_start_time) {
//         const start = new Date(activeTask.actual_start_time.replace(/-/g, "/")).getTime();
//         const diff = Math.floor((Date.now() - start) / 1000);
//         setTimer(diff > 0 ? diff : 0);
//       } else {
//         setTimer(0);
//       }
//     }, 1000);
//     return () => clearInterval(interval);
//   }, [tasks]);

//   //  Search / Reset 
//   const handleSearch = () => {
//     setFilterFromDate(fromDate);
//     setFilterToDate(toDate);
//   };

//   const handleReset = () => {
//     setFromDate("");
//     setToDate("");
//     setFilterFromDate("");
//     setFilterToDate("");
//     setStatusFilter("all");
//     activeJob(1, 15, "", "", "all");
//   };

//   //  Task actions 
//   const refreshList = () =>
//     activeJob(pagination.current_page, pagination.per_page, filterToDate, filterFromDate, statusFilter);

//     const startTaskById = async (taskId) => {
//     if (!punchedIn) { toast.error("Please punch in to start task."); return; }
//     try {
//       const res = await configService.changeStatus(taskId, { action: "start" });
//       if (res.status) { toast.success(res.message || "Task started"); refreshList(); }
//       else { toast.error(res.message || "Failed to start task."); }
//     } catch (err) {
//       toast.error(err?.response?.data?.message || err?.message || "Failed to start task.");
//     }
//   };

//   const holdTaskById = async (taskId) => {
//     try {
//       const res = await configService.changeStatus(taskId, { action: "hold" });
//       if (res.status) { toast.success(res.message || "Task on hold"); refreshList(); }
//       else { toast.error(res.message || "Failed to hold task."); }
//     } catch (err) {
//       toast.error(err?.response?.data?.message || err?.message || "Failed to hold task.");
//     }
//   };

//   const resumeTaskById = async (taskId) => {
//     try {
//       const res = await configService.changeStatus(taskId, { action: "resume" });
//       if (res.status) { toast.success(res.message || "Task resumed"); refreshList(); }
//       else { toast.error(res.message || "Failed to resume task."); }
//     } catch (err) {
//       toast.error(err?.response?.data?.message || err?.message || "Failed to resume task.");
//     }
//   };

//   //  Complete flow — modal open karo, koi upload yaha nahi hota 
//   const handleCompleteClick = (taskId) => {
//     setPendingTaskId(taskId);
//     setPhotos([]);
//     setPhotoModalOpen(true);
//   };

//   //  Photo handlers — sirf local state me add hote hai, backend call NAHI 
//   const handleFileSelectWithSource = (event) => {
//     const files = Array.from(event.target.files);
//     const current = photosRef.current.length;
//     const remaining = MAX_PHOTOS - current;

//     if (remaining <= 0) {
//       toast.error(`Maximum ${MAX_PHOTOS} photos allowed.`);
//       event.target.value = "";
//       return;
//     }

//     if (files.length > remaining) {
//       toast.error(`Only ${remaining} more photo(s) allowed. Max ${MAX_PHOTOS}.`);
//       event.target.value = "";
//       return;
//     }
//     if (!pendingTaskId) { toast.error("No task selected."); event.target.value = ""; return; }

//     setPhotos((prev) => [
//       ...prev,
//       ...files.map((file) => ({ file, previewUrl: URL.createObjectURL(file), source: "gallery" })),
//     ]);
//     event.target.value = "";
//     // ❌ Yahan pehle uploadProof() call hota tha — hata diya.
//     // Photos ab sirf "Complete Task" button dabane par backend jaayenge.
//   };

//   const removePhoto = (idx) => {
//     setPhotos((prev) => {
//       const updated = [...prev];
//       URL.revokeObjectURL(updated[idx].previewUrl);
//       updated.splice(idx, 1);
//       return updated;
//     });
//   };

//   const openCamera = async () => {
//     setCameraOpen(true);
//     try {
//       const mediaStream = await navigator.mediaDevices.getUserMedia({ video: true });
//       setStream(mediaStream);
//       if (videoRef.current) videoRef.current.srcObject = mediaStream;
//     } catch {
//       toast.error("Unable to access camera.");
//       setCameraOpen(false);
//     }
//   };

//   const capturePhotoWithSource = () => {
//     if (!videoRef.current || !canvasRef.current) return;

//     const current = photosRef.current.length;
//     if (current >= MAX_PHOTOS) {
//       toast.error(`Maximum ${MAX_PHOTOS} photos allowed.`);
//       return;
//     }

//     const video = videoRef.current;
//     const canvas = canvasRef.current;
//     canvas.width = video.videoWidth;
//     canvas.height = video.videoHeight;
//     canvas.getContext("2d").drawImage(video, 0, 0);
//     canvas.toBlob((blob) => {
//       const file = new File([blob], `captured-${Date.now()}.jpg`, { type: "image/jpeg" });
//       setPhotos((prev) => [...prev, { file, previewUrl: URL.createObjectURL(file), source: "camera" }]);
//       toast.success("Photo captured!");
//     }, "image/jpeg", 0.9);
//   };

//   const closeCamera = () => {
//     stream?.getTracks().forEach((t) => t.stop());
//     setStream(null);
//     setCameraOpen(false);
//   };

//   const closePhotoModal = () => {
//     if (cameraOpen) closeCamera();
//     setPhotoModalOpen(false);
//     photos.forEach((p) => URL.revokeObjectURL(p.previewUrl));
//     setPhotos([]);
//   };

//   //  Complete Task — ek hi request me action=complete + saari photos backend jaati hai 
//   // const submitPhotosAndComplete = async () => {
//   //   if (!pendingTaskId) return;

//   //   if (photos.length < MIN_PHOTOS) {
//   //     toast.error(`At least ${MIN_PHOTOS} photo is required.`);
//   //     return;
//   //   }
//   //   if (photos.length > MAX_PHOTOS) {
//   //     toast.error(`Maximum ${MAX_PHOTOS} photos allowed.`);
//   //     return;
//   //   }

//   //   try {
//   //     setCompleting(true);
//   //     const { latitude, longitude } = await getGeolocation();

//   //     const formData = new FormData();
//   //     formData.append("action", "complete");
//   //     photos.forEach((p) => formData.append("photos[]", p.file));
//   //     if (latitude !== null) formData.append("latitude", latitude);
//   //     if (longitude !== null) formData.append("longitude", longitude);

//   //     toast.loading("Completing task...", { id: "complete-task" });

//   //     // configService.changeStatus multipart FormData accept karega
//   //     const res = await configService.changeStatus(pendingTaskId, formData);

//   //     if (res.status) {
//   //       toast.success(res.message || "Task completed", { id: "complete-task" });
//   //       refreshList();
//   //       photos.forEach((p) => URL.revokeObjectURL(p.previewUrl));
//   //       setPhotoModalOpen(false);
//   //       setPendingTaskId(null);
//   //       setPhotos([]);
//   //     } else {
//   //       toast.error(res.message || "Failed to complete task.", { id: "complete-task" });
//   //     }
//   //   } catch (err) {
//   //     toast.error(err?.response?.data?.message || err?.message || "Failed to complete task.", { id: "complete-task" });
//   //   } finally {
//   //     setCompleting(false);
//   //   }
//   // };

//   const submitPhotosAndComplete = async () => {
//   if (!pendingTaskId) return;

//   if (photos.length === 0) {
//     toast.error("Please upload or capture at least 1 photo.");
//     return;
//   }
//   if (photos.length > 3) {
//     toast.error("Maximum 3 photos allowed.");
//     return;
//   }

//   try {
//     const { latitude, longitude } = await getGeolocation();
//     const formData = new FormData();
//     formData.append("action", "complete");

//     // Backend indexed fields expect karta hai: photo_0, photo_1, photo_2
//     photos.forEach((p, i) => formData.append(`photo_${i}`, p.file));

//     if (latitude !== null) formData.append("latitude", latitude);
//     if (longitude !== null) formData.append("longitude", longitude);

//     const res = await configService.changeStatus(pendingTaskId, formData);

//     if (res.status) {
//       toast.success(res.message || "Task completed");
//       refreshList();
//     } else {
//       toast.error(res.message || "Failed to complete task.");
//     }
//   } catch (err) {
//     toast.error(err?.response?.data?.message || err?.message || "Failed to complete task.");
//   }

//   photos.forEach((p) => URL.revokeObjectURL(p.previewUrl));
//   setPhotoModalOpen(false);
//   setPendingTaskId(null);
//   setPhotos([]);
// };

//   const formatTime = (sec) => {
//     const m = Math.floor(sec / 60);
//     const s = sec % 60;
//     return `${m}:${s < 10 ? "0" : ""}${s}`;
//   };

//   const isAnyJobRunning = tasks.some((t) => t.status === "in_progress");
//   const currentRunningJob = tasks.find((t) => t.status === "in_progress");
//   const isSlaBreached = currentRunningJob ? timer < currentRunningJob.sla_minutes * 60 : true;

//   const isCompleteDisabled =
//     completing || photos.length < MIN_PHOTOS || photos.length > MAX_PHOTOS;

//   const filterFieldSx = {
//     minWidth: 220,
//     "& .MuiOutlinedInput-root": {
//       color: "#fff",
//       "& fieldset": {
//         borderColor: "#fff",
//       },
//       "&:hover fieldset": {
//         borderColor: "#fff",
//       },
//       "&.Mui-focused fieldset": {
//         borderColor: "#fff",
//       },
//     },
//     "& .MuiInputLabel-root": {
//       color: "rgba(255, 255, 255, 0.85)",
//     },
//     "& .MuiInputLabel-root.Mui-focused": {
//       color: "#fff",
//     },
//     "& .MuiSelect-icon": {
//       color: "#fff",
//     },
//     "& input[type='date']::-webkit-calendar-picker-indicator": {
//       filter: "invert(1)",
//     },
//   };

//   const PaginationFieldSx = {
//     // Pure component ka text color white karne ke liye
//     color: '#000000 !important',

//     // "Rows per page:" text ke liye
//     '& .MuiTablePagination-selectLabel': {
//       color: '#000000 !important',
//     },

//     // "1-20 of 46" text ke liye
//     '& .MuiTablePagination-displayedRows': {
//       color: '#000000 !important',
//     },

//     // Dropdown select box aur uske andar ke number (20) ke liye
//     '& .MuiTablePagination-select': {
//       color: '#000000 !important',
//     },

//     // Dropdown ke chote down-arrow icon ke liye
//     '& .MuiTablePagination-selectIcon': {
//       color: '#000000 !important',
//     },

//     // Next aur Previous page ke arrow icons/buttons ke liye
//     '& .MuiTablePagination-actions .MuiButtonBase-root': {
//       color: '#000000 !important',
//       '&.Mui-disabled': {
//         color: 'rgb(0, 0, 0) !important', // Jo arrow disabled ho woh halka dikhega
//       },
//     },
//   };


//   return (
//     <Box sx={{ p: 3, bgcolor: "#f4f6f9", minHeight: "100vh" }}>

//       {/* ── Timer card ── */}
//       <Card sx={{
//         bgcolor: "#ffffff", color: "#1e293b", p: 4, borderRadius: 4,
//         display: "flex", justifyContent: "center", alignItems: "center", mb: 4,
//         boxShadow: "0 10px 25px rgba(0,0,0,0.05)", border: "1px solid #e2e8f0"
//       }}>
//         <Box sx={{
//           width: 180, height: 180, borderRadius: "50%", border: "6px solid #1976d2",
//           display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"
//         }}>
//           <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>RUNNING TASK</Typography>
//           <Typography sx={{ fontSize: 24, fontFamily: "monospace", color: "#1e293b", fontWeight: "bold" }}>{formatTime(timer)}</Typography>
//           {currentRunningJob && (
//             <Button size="small" variant="contained" color="success"
//               onClick={() => handleCompleteClick(currentRunningJob.id)}
//               disabled={isSlaBreached} sx={{ mt: 1, color: "#fff", textTransform: "none", fontWeight: "bold" }}>
//               {isSlaBreached ? `Wait ${currentRunningJob.sla_minutes} min` : "Complete"}
//             </Button>
//           )}
//         </Box>
//       </Card>

//       {/* ── Task list card ── */}
//       <Card sx={{ bgcolor: "#ffffff", color: "#1e293b", borderRadius: 4, boxShadow: "0 10px 25px rgba(0,0,0,0.05)", border: "1px solid #e2e8f0" }}>
//         <Box sx={{ p: 3 }}>
//           <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold", color: "#1e293b" }}>All Tasks</Typography>

//           {/* Filters */}
//           <Box sx={{
//             display: "flex", justifyContent: "space-between",
//             alignItems: "center", gap: 3, mb: 3, flexWrap: "wrap"
//           }}>

//             <FormControl size="small" sx={{ minWidth: 140 }}>
//               <InputLabel sx={{
//                 color: "rgba(0, 0, 0, 0.6)",
//                 "&.Mui-focused": { color: "#1976d2" }
//               }}>
//                 Status
//               </InputLabel>
//               <Select
//                 value={statusFilter}
//                 label="Status"
//                 sx={{
//                   color: "#1e293b",
//                   bgcolor: "#f8fafc",
//                   ".MuiOutlinedInput-notchedOutline": { borderColor: "#cbd5e1" },
//                   "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#94a3b8" },
//                   "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#1976d2" }
//                 }}
//                 onChange={(e) => setStatusFilter(e.target.value)}
//               >
//                 <MenuItem value="all">All</MenuItem>
//                 <MenuItem value="new">New</MenuItem>
//                 <MenuItem value="running">Running</MenuItem>
//                 <MenuItem value="hold">On Hold</MenuItem>
//                 <MenuItem value="completed">Completed</MenuItem>
//               </Select>
//             </FormControl>

//             <Box sx={{ display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
//               <TextField
//                 size="small"
//                 type="date"
//                 label="Start Date"
//                 InputLabelProps={{ shrink: true }}
//                 value={fromDate}
//                 onChange={(e) => setFromDate(e.target.value)}
//                 sx={{
//                   bgcolor: "#f8fafc",
//                   "& .MuiInputBase-input": { color: "#1e293b" },
//                   "& .MuiInputLabel-root": { color: "rgba(0, 0, 0, 0.6)" },
//                   "& .MuiInputLabel-root.Mui-focused": { color: "#1976d2" },
//                   "& .MuiOutlinedInput-root": {
//                     "& fieldset": { borderColor: "#cbd5e1" },
//                     "&:hover fieldset": { borderColor: "#94a3b8" },
//                     "&.Mui-focused fieldset": { borderColor: "#1976d2" }
//                   }
//                 }}
//               />

//               <TextField
//                 size="small"
//                 type="date"
//                 label="End Date"
//                 InputLabelProps={{ shrink: true }}
//                 value={toDate}
//                 onChange={(e) => setToDate(e.target.value)}
//                 sx={{
//                   bgcolor: "#f8fafc",
//                   "& .MuiInputBase-input": { color: "#1e293b" },
//                   "& .MuiInputLabel-root": { color: "rgba(0, 0, 0, 0.6)" },
//                   "& .MuiInputLabel-root.Mui-focused": { color: "#1976d2" },
//                   "& .MuiOutlinedInput-root": {
//                     "& fieldset": { borderColor: "#cbd5e1" },
//                     "&:hover fieldset": { borderColor: "#94a3b8" },
//                     "&.Mui-focused fieldset": { borderColor: "#1976d2" }
//                   }
//                 }}
//               />

//               <Button variant="contained" onClick={handleSearch} sx={{ height: 40, minWidth: 100, fontWeight: "bold" }}>
//                 Search
//               </Button>
//               <Button color="error" variant="outlined" onClick={handleReset} sx={{ height: 40, minWidth: 100, fontWeight: "bold", bgcolor: "#fff", "&:hover": { bgcolor: "#fef2f2" } }}>
//                 Reset
//               </Button>
//             </Box>
//           </Box>

//           {/* Table */}
//           <Table>
//             <TableHead>
//               <TableRow sx={{ bgcolor: "#f8fafc" }}>
//                 <TableCell sx={{ color: "#475569", fontWeight: "bold" }}>Task</TableCell>
//                 <TableCell sx={{ color: "#475569", fontWeight: "bold" }}>Duration</TableCell>
//                 <TableCell sx={{ color: "#475569", fontWeight: "bold" }}>Status</TableCell>
//                 <TableCell sx={{ color: "#475569", fontWeight: "bold" }}>Action</TableCell>
//               </TableRow>
//             </TableHead>

//             <TableBody>
//               {loading ? (
//                 <TableRow>
//                   <TableCell colSpan={4} sx={{ color: "#64748b", textAlign: "center" }}>
//                     Loading...
//                   </TableCell>
//                 </TableRow>
//               ) : tasks.length === 0 ? (
//                 <TableRow>
//                   <TableCell colSpan={4} sx={{ color: "#64748b", textAlign: "center" }}>
//                     No tasks found.
//                   </TableCell>
//                 </TableRow>
//               ) : tasks.map((task) => {
//                 const dbStatus = task.status;
//                 const displayStatus = getDisplayStatus(dbStatus);
//                 const statusColor = getStatusColor(dbStatus);
//                 const isSlaMinutesPending = timer < task.sla_minutes * 60;

//                 return (
//                   <TableRow key={task.id} sx={{ '&:hover': { bgcolor: '#f8fafc' } }}>
//                     <TableCell sx={{ color: "#1e293b", fontWeight: 500 }}>{task.job_name}</TableCell>
//                     <TableCell sx={{ color: "#475569" }}>{task.sla_minutes} min</TableCell>
//                     <TableCell sx={{ color: statusColor, fontWeight: "bold" }}>{displayStatus}</TableCell>

//                     <TableCell>
//                       {dbStatus === "new" && (
//                         <Button size="small" variant="contained"
//                           onClick={() => startTaskById(task.id)}
//                           disabled={isAnyJobRunning}
//                           sx={{ bgcolor: "#1976d2", color: "#fff", fontWeight: "bold" }}>
//                           Start
//                         </Button>
//                       )}

//                       {dbStatus === "in_progress" && (
//                         <Box sx={{ display: "flex", gap: 1 }}>
//                           <Button size="small" variant="contained" color="success"
//                             onClick={() => handleCompleteClick(task.id)}
//                             disabled={isSlaMinutesPending}
//                             sx={{ fontWeight: "bold" }}>
//                             Complete
//                           </Button>
//                           <Button size="small" variant="contained" color="warning"
//                             onClick={() => holdTaskById(task.id)}
//                             sx={{ fontWeight: "bold" }}>
//                             Hold
//                           </Button>
//                         </Box>
//                       )}

//                       {dbStatus === "hold" && (
//                         <Box sx={{ display: "flex", gap: 1 }}>
//                           <Button size="small" variant="contained" color="primary"
//                             onClick={() => resumeTaskById(task.id)}
//                             disabled={isAnyJobRunning}
//                             sx={{ fontWeight: "bold" }}>
//                             Resume
//                           </Button>
//                           <Button size="small" variant="contained" color="success" disabled>
//                             Complete
//                           </Button>
//                         </Box>
//                       )}

//                       {dbStatus === "completed" && (
//                         <Typography sx={{ color: "#2e7d32", fontWeight: "bold" }}>Done</Typography>
//                       )}

//                       {dbStatus === "cancelled" && (
//                         <Typography sx={{ color: "#d32f2f", fontWeight: "bold" }}>Cancelled</Typography>
//                       )}
//                     </TableCell>
//                   </TableRow>
//                 );
//               })}
//             </TableBody>
//           </Table>

//           <TablePagination
//             component="div"
//             count={pagination.total}
//             page={pagination.current_page - 1}
//             rowsPerPage={pagination.per_page}
//             onPageChange={handleChangePage}
//             onRowsPerPageChange={handleChangeRowsPerPage}
//             rowsPerPageOptions={[5, 10, 20, 50]}
//             sx={{
//               ...PaginationFieldSx,
//               color: "#1e293b",
//               ".MuiTablePagination-actions": { color: "#1976d2" }
//             }}
//           />
//         </Box>
//       </Card>

//       {/* ── Photo modal ── */}
//       <Dialog open={photoModalOpen} onClose={closePhotoModal} maxWidth="md" fullWidth>

//         <DialogTitle sx={{ color: "#1e293b", fontWeight: "bold" }}>
//           Upload / Capture Photos
//           <IconButton onClick={closePhotoModal} sx={{ position: "absolute", right: 8, top: 8, color: "#64748b" }}>
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent dividers sx={{ bgcolor: "#fff" }}>
//           {!cameraOpen ? (
//             <>
//               <Alert severity="info" sx={{ mb: 2, bgcolor: "#f0f9ff", color: "#0369a1", border: "1px solid #bae6fd" }}>
//                 • Minimum {MIN_PHOTOS} photo required to complete task<br />
//                 • Maximum {MAX_PHOTOS} photos allowed (Gallery + Camera combined)<br />
//                 • Photos will be uploaded only when you click "Complete Task"
//               </Alert>
//               <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
//                 <Button
//                   variant="outlined"
//                   component="label"
//                   startIcon={<PhotoLibraryIcon />}
//                   disabled={photos.length >= MAX_PHOTOS}
//                   sx={{ textTransform: "none", fontWeight: "bold" }}
//                 >
//                   Upload from Gallery (Max {MAX_PHOTOS})
//                   <input type="file" accept="image/*" multiple hidden
//                     onChange={handleFileSelectWithSource} />
//                 </Button>
//                 <Button
//                   variant="outlined"
//                   onClick={openCamera}
//                   startIcon={<CameraAltIcon />}
//                   disabled={photos.length >= MAX_PHOTOS}
//                   sx={{ textTransform: "none", fontWeight: "bold" }}
//                 >
//                   Open Live Camera
//                 </Button>
//               </Box>

//               {photos.length > 0 && (
//                 <>
//                   <Typography variant="subtitle2" sx={{ mt: 2, mb: 1, color: "#1e293b", fontWeight: "bold" }}>
//                     Selected Photos ({photos.length}/{MAX_PHOTOS})
//                   </Typography>
//                   <Grid container spacing={2}>
//                     {photos.map((photo, idx) => (
//                       <Grid item xs={6} sm={4} md={3} key={idx}>
//                         <Box sx={{ position: "relative", boxShadow: "0 4px 12px rgba(0,0,0,0.1)", borderRadius: 2, overflow: "hidden" }}>
//                           <img src={photo.previewUrl} alt={`preview-${idx}`}
//                             style={{ width: "100%", height: 120, objectFit: "cover", display: "block" }} />
//                           <IconButton size="small" onClick={() => removePhoto(idx)}
//                             sx={{ position: "absolute", top: 4, right: 4, bgcolor: "rgba(0,0,0,0.6)", '&:hover': { bgcolor: "rgba(0,0,0,0.8)" } }}>
//                             <DeleteIcon fontSize="small" sx={{ color: "#fff" }} />
//                           </IconButton>
//                           {photo.source === "camera" && (
//                             <Typography variant="caption" sx={{
//                               position: "absolute", bottom: 4, left: 4,
//                               bgcolor: "rgba(25,118,210,0.85)", color: "#fff", px: 1, borderRadius: 1, fontWeight: 500
//                             }}>Camera</Typography>
//                           )}
//                         </Box>
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </>
//               )}
//             </>
//           ) : (
//             <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
//               <video ref={videoRef} autoPlay playsInline style={{ width: "100%", maxWidth: 500, borderRadius: 8, border: "2px solid #1976d2" }} />
//               <canvas ref={canvasRef} style={{ display: "none" }} />
//               <Box sx={{ display: "flex", gap: 2 }}>
//                 <Button variant="contained" color="primary"
//                   onClick={capturePhotoWithSource}
//                   disabled={photos.length >= MAX_PHOTOS}
//                   startIcon={<CapturePhotoIcon />} sx={{ fontWeight: "bold" }}>
//                   Capture Photo
//                 </Button>
//                 <Button variant="outlined" color="error" onClick={closeCamera} sx={{ fontWeight: "bold" }}>
//                   Close Camera
//                 </Button>
//               </Box>
//               <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>
//                 Captured: {photos.length} / Max {MAX_PHOTOS}
//               </Typography>
//             </Box>
//           )}
//         </DialogContent>

//         <DialogActions sx={{ p: 2, bgcolor: "#f8fafc" }}>
//           {!cameraOpen && (
//             <Button onClick={submitPhotosAndComplete} variant="contained" color="success"
//               disabled={isCompleteDisabled}
//               sx={{ px: 4, fontWeight: "bold" }}>
//               {completing ? "Uploading..." : `Complete Task (${photos.length} photo(s))`}
//             </Button>
//           )}
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default Jobs;






import React, { useEffect, useState, useRef } from "react";
import TablePagination from "@mui/material/TablePagination";
import { useSelector } from "react-redux";
import {
  Box,
  Card,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Grid,
  Alert,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { useAttendance } from "../context/AttendanceContext";
import configService from "../services/config";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import CapturePhotoIcon from "@mui/icons-material/PhotoCamera";
import DeleteIcon from "@mui/icons-material/Delete";

// ── Photo limits ──
const MIN_PHOTOS = 1;
const MAX_PHOTOS = 3;

const Jobs = () => {
  const location = useLocation();

  const [pagination, setPagination] = useState({
    total: 0,
    per_page: 15,
    current_page: 1,
    last_page: 1,
  });

  const [tasks, setTasks] = useState([]);
  const [timer, setTimer] = useState(0);
  const [loading, setLoading] = useState(false);

  const { company_id, userId } = useSelector((state) => state.globalVariables);

  const { punchedIn } = useAttendance();

  const [statusFilter, setStatusFilter] = useState("all");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filterFromDate, setFilterFromDate] = useState("");
  const [filterToDate, setFilterToDate] = useState("");

  const [photoModalOpen, setPhotoModalOpen] = useState(false);
  const [pendingTaskId, setPendingTaskId] = useState(null);
  const [photos, setPhotos] = useState([]);
  const [cameraOpen, setCameraOpen] = useState(false);
  const [stream, setStream] = useState(null);
  const [completing, setCompleting] = useState(false);

  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const photosRef = useRef(photos);
  useEffect(() => { photosRef.current = photos; }, [photos]);

  const getGeolocation = () =>
    new Promise((resolve) => {
      if (!navigator.geolocation) return resolve({ latitude: null, longitude: null });
      navigator.geolocation.getCurrentPosition(
        (pos) => resolve({ latitude: pos.coords.latitude, longitude: pos.coords.longitude }),
        () => resolve({ latitude: null, longitude: null })
      );
    });

  const mapStatusToFilter = (uiValue) => {
    const map = {
      all: "all",
      new: "pending",
      running: "current",
      hold: "hold",
      completed: "completed",
    };
    return map[uiValue] ?? "all";
  };

  const getDisplayStatus = (dbStatus) => {
    const map = {
      new: "New",
      in_progress: "Running",
      hold: "On Hold",
      completed: "Completed",
      cancelled: "Cancelled",
    };
    return map[dbStatus] ?? "New";
  };

  const getStatusColor = (dbStatus) => {
    const map = {
      new: "#42a5f5",
      in_progress: "#42a5f5",
      hold: "#f39c12",
      completed: "#2ecc71",
      cancelled: "#e74c3c",
    };
    return map[dbStatus] ?? "#42a5f5";
  };

  const activeJob = async (
    page = 1,
    perPage = 15,
    toDate = "",
    fromDate = "",
    statusUi = "all"
  ) => {
    try {
      setLoading(true);

      const payload = {
        company_id,
        staff_id: userId,
        filter: mapStatusToFilter(statusUi),
        page,
        per_page: perPage,
        ...(fromDate ? { from_date: fromDate } : {}),
        ...(toDate ? { to_date: toDate } : {}),
      };

      const response = await configService.getMyJobs(payload);

      if (response.status) {
        setTasks(response.data || []);
        setPagination(response.pagination);
      } else {
        toast.error(response.message || "Failed to load tasks.");
      }
    } catch (error) {
      console.error("Error fetching job details:", error);
      toast.error("Failed to load tasks.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    activeJob();
  }, []);

  useEffect(() => {
    activeJob(1, 15, filterToDate, filterFromDate, statusFilter);
  }, [filterFromDate, filterToDate, statusFilter]);

  const handleChangePage = (event, newPage) => {
    activeJob(newPage + 1, pagination.per_page, filterToDate, filterFromDate, statusFilter);
  };

  const handleChangeRowsPerPage = (event) => {
    const newPerPage = parseInt(event.target.value, 10);
    activeJob(1, newPerPage, filterToDate, filterFromDate, statusFilter);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const activeTask = tasks.find((t) => t.status === "in_progress");
      if (activeTask?.actual_start_time) {
        const start = new Date(activeTask.actual_start_time.replace(/-/g, "/")).getTime();
        const diff = Math.floor((Date.now() - start) / 1000);
        setTimer(diff > 0 ? diff : 0);
      } else {
        setTimer(0);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [tasks]);

  const handleSearch = () => {
    setFilterFromDate(fromDate);
    setFilterToDate(toDate);
  };

  const handleReset = () => {
    setFromDate("");
    setToDate("");
    setFilterFromDate("");
    setFilterToDate("");
    setStatusFilter("all");
    activeJob(1, 15, "", "", "all");
  };

  const refreshList = () =>
    activeJob(pagination.current_page, pagination.per_page, filterToDate, filterFromDate, statusFilter);

  const startTaskById = async (taskId) => {
    if (!punchedIn) { toast.error("Please punch in to start task."); return; }
    try {
      const res = await configService.changeStatus(taskId, { action: "start" });
      if (res.status) { toast.success(res.message || "Task started"); refreshList(); }
      else { toast.error(res.message || "Failed to start task."); }
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.message || "Failed to start task.");
    }
  };

  const holdTaskById = async (taskId) => {
    try {
      const res = await configService.changeStatus(taskId, { action: "hold" });
      if (res.status) { toast.success(res.message || "Task on hold"); refreshList(); }
      else { toast.error(res.message || "Failed to hold task."); }
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.message || "Failed to hold task.");
    }
  };

  const resumeTaskById = async (taskId) => {
    try {
      const res = await configService.changeStatus(taskId, { action: "resume" });
      if (res.status) { toast.success(res.message || "Task resumed"); refreshList(); }
      else { toast.error(res.message || "Failed to resume task."); }
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.message || "Failed to resume task.");
    }
  };

  const handleCompleteClick = (taskId) => {
    setPendingTaskId(taskId);
    setPhotos([]);
    setPhotoModalOpen(true);
  };

  const handleFileSelectWithSource = (event) => {
    const files = Array.from(event.target.files);
    const current = photosRef.current.length;
    const remaining = MAX_PHOTOS - current;

    if (remaining <= 0) {
      toast.error(`Maximum ${MAX_PHOTOS} photos allowed.`);
      event.target.value = "";
      return;
    }

    if (files.length > remaining) {
      toast.error(`Only ${remaining} more photo(s) allowed. Max ${MAX_PHOTOS}.`);
      event.target.value = "";
      return;
    }
    if (!pendingTaskId) { toast.error("No task selected."); event.target.value = ""; return; }

    setPhotos((prev) => [
      ...prev,
      ...files.map((file) => ({ file, previewUrl: URL.createObjectURL(file), source: "gallery" })),
    ]);
    event.target.value = "";
  };

  const removePhoto = (idx) => {
    setPhotos((prev) => {
      const updated = [...prev];
      URL.revokeObjectURL(updated[idx].previewUrl);
      updated.splice(idx, 1);
      return updated;
    });
  };

  const openCamera = async () => {
    setCameraOpen(true);
    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({ video: true });
      setStream(mediaStream);
      if (videoRef.current) videoRef.current.srcObject = mediaStream;
    } catch {
      toast.error("Unable to access camera.");
      setCameraOpen(false);
    }
  };

  const capturePhotoWithSource = () => {
    if (!videoRef.current || !canvasRef.current) return;

    const current = photosRef.current.length;
    if (current >= MAX_PHOTOS) {
      toast.error(`Maximum ${MAX_PHOTOS} photos allowed.`);
      return;
    }

    const video = videoRef.current;
    const canvas = canvasRef.current;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext("2d").drawImage(video, 0, 0);
    canvas.toBlob((blob) => {
      const file = new File([blob], `captured-${Date.now()}.jpg`, { type: "image/jpeg" });
      setPhotos((prev) => [...prev, { file, previewUrl: URL.createObjectURL(file), source: "camera" }]);
      toast.success("Photo captured!");
    }, "image/jpeg", 0.9);
  };

  const closeCamera = () => {
    stream?.getTracks().forEach((t) => t.stop());
    setStream(null);
    setCameraOpen(false);
  };

  const closePhotoModal = () => {
    if (cameraOpen) closeCamera();
    setPhotoModalOpen(false);
    photos.forEach((p) => URL.revokeObjectURL(p.previewUrl));
    setPhotos([]);
  };

  const submitPhotosAndComplete = async () => {
    if (!pendingTaskId) return;

    if (photos.length === 0) {
      toast.error("Please upload or capture at least 1 photo.");
      return;
    }
    if (photos.length > 3) {
      toast.error("Maximum 3 photos allowed.");
      return;
    }

    try {
      const { latitude, longitude } = await getGeolocation();
      const formData = new FormData();
      formData.append("action", "complete");

      photos.forEach((p, i) => formData.append(`photo_${i}`, p.file));

      if (latitude !== null) formData.append("latitude", latitude);
      if (longitude !== null) formData.append("longitude", longitude);

      const res = await configService.changeStatus(pendingTaskId, formData);

      if (res.status) {
        toast.success(res.message || "Task completed");
        refreshList();
      } else {
        toast.error(res.message || "Failed to complete task.");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.message || "Failed to complete task.");
    }

    photos.forEach((p) => URL.revokeObjectURL(p.previewUrl));
    setPhotoModalOpen(false);
    setPendingTaskId(null);
    setPhotos([]);
  };

  const formatTime = (sec) => {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${m}:${s < 10 ? "0" : ""}${s}`;
  };

  const isAnyJobRunning = tasks.some((t) => t.status === "in_progress");
  const currentRunningJob = tasks.find((t) => t.status === "in_progress");
  const isSlaBreached = currentRunningJob ? timer < currentRunningJob.sla_minutes * 60 : true;

  const isCompleteDisabled =
    completing || photos.length < MIN_PHOTOS || photos.length > MAX_PHOTOS;

  const PaginationFieldSx = {
    color: '#000000 !important',
    '& .MuiTablePagination-selectLabel': { color: '#000000 !important' },
    '& .MuiTablePagination-displayedRows': { color: '#000000 !important' },
    '& .MuiTablePagination-select': { color: '#000000 !important' },
    '& .MuiTablePagination-selectIcon': { color: '#000000 !important' },
    '& .MuiTablePagination-actions .MuiButtonBase-root': {
      color: '#000000 !important',
      '&.Mui-disabled': { color: 'rgb(0, 0, 0) !important' },
    },
  };

  return (
    <Box sx={{ p: 3, bgcolor: "#f4f6f9", minHeight: "100vh" }}>

      {/* ── Timer card ── */}
      <Card sx={{
        bgcolor: "#ffffff", color: "#1e293b", p: 4, borderRadius: 4,
        display: "flex", justifyContent: "center", alignItems: "center", mb: 4,
        boxShadow: "0 10px 25px rgba(0,0,0,0.05)", border: "1px solid #e2e8f0"
      }}>
        <Box sx={{
          width: 180, height: 180, borderRadius: "50%", border: "6px solid #1976d2",
          display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"
        }}>
          <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>RUNNING TASK</Typography>
          <Typography sx={{ fontSize: 24, fontFamily: "monospace", color: "#1e293b", fontWeight: "bold" }}>{formatTime(timer)}</Typography>
          {currentRunningJob && (
            <Button size="small" variant="contained" color="success"
              onClick={() => handleCompleteClick(currentRunningJob.id)}
              disabled={isSlaBreached} sx={{ mt: 1, color: "#fff", textTransform: "none", fontWeight: "bold" }}>
              {isSlaBreached ? `Wait ${currentRunningJob.sla_minutes} min` : "Complete"}
            </Button>
          )}
        </Box>
      </Card>

      {/* ── Task list card ── */}
      <Card sx={{ bgcolor: "#ffffff", color: "#1e293b", borderRadius: 4, boxShadow: "0 10px 25px rgba(0,0,0,0.05)", border: "1px solid #e2e8f0" }}>
        <Box sx={{ p: 3 }}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold", color: "#1e293b" }}>All Tasks</Typography>

          <Box sx={{
            display: "flex", justifyContent: "space-between",
            alignItems: "center", gap: 3, mb: 3, flexWrap: "wrap"
          }}>

            <FormControl size="small" sx={{ minWidth: 140 }}>
              <InputLabel sx={{
                color: "rgba(0, 0, 0, 0.6)",
                "&.Mui-focused": { color: "#1976d2" }
              }}>
                Status
              </InputLabel>
              <Select
                value={statusFilter}
                label="Status"
                sx={{
                  color: "#1e293b",
                  bgcolor: "#f8fafc",
                  ".MuiOutlinedInput-notchedOutline": { borderColor: "#cbd5e1" },
                  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#94a3b8" },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#1976d2" }
                }}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="new">New</MenuItem>
                <MenuItem value="running">Running</MenuItem>
                <MenuItem value="hold">On Hold</MenuItem>
                <MenuItem value="completed">Completed</MenuItem>
              </Select>
            </FormControl>

            <Box sx={{ display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
              <TextField
                size="small"
                type="date"
                label="Start Date"
                InputLabelProps={{ shrink: true }}
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                sx={{
                  bgcolor: "#f8fafc",
                  "& .MuiInputBase-input": { color: "#1e293b" },
                  "& .MuiInputLabel-root": { color: "rgba(0, 0, 0, 0.6)" },
                  "& .MuiInputLabel-root.Mui-focused": { color: "#1976d2" },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: "#cbd5e1" },
                    "&:hover fieldset": { borderColor: "#94a3b8" },
                    "&.Mui-focused fieldset": { borderColor: "#1976d2" }
                  }
                }}
              />

              <TextField
                size="small"
                type="date"
                label="End Date"
                InputLabelProps={{ shrink: true }}
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                sx={{
                  bgcolor: "#f8fafc",
                  "& .MuiInputBase-input": { color: "#1e293b" },
                  "& .MuiInputLabel-root": { color: "rgba(0, 0, 0, 0.6)" },
                  "& .MuiInputLabel-root.Mui-focused": { color: "#1976d2" },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: "#cbd5e1" },
                    "&:hover fieldset": { borderColor: "#94a3b8" },
                    "&.Mui-focused fieldset": { borderColor: "#1976d2" }
                  }
                }}
              />

              <Button variant="contained" onClick={handleSearch} sx={{ height: 40, minWidth: 100, fontWeight: "bold" }}>
                Search
              </Button>
              <Button color="error" variant="outlined" onClick={handleReset} sx={{ height: 40, minWidth: 100, fontWeight: "bold", bgcolor: "#fff", "&:hover": { bgcolor: "#fef2f2" } }}>
                Reset
              </Button>
            </Box>
          </Box>

          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: "#f8fafc" }}>
                <TableCell sx={{ color: "#475569", fontWeight: "bold" }}>Task</TableCell>
                <TableCell sx={{ color: "#475569", fontWeight: "bold" }}>Duration</TableCell>
                <TableCell sx={{ color: "#475569", fontWeight: "bold" }}>Status</TableCell>
                <TableCell sx={{ color: "#475569", fontWeight: "bold" }}>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={4} sx={{ color: "#64748b", textAlign: "center" }}>
                    Loading...
                  </TableCell>
                </TableRow>
              ) : tasks.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} sx={{ color: "#64748b", textAlign: "center" }}>
                    No tasks found.
                  </TableCell>
                </TableRow>
              ) : tasks.map((task) => {
                const dbStatus = task.status;
                const displayStatus = getDisplayStatus(dbStatus);
                const statusColor = getStatusColor(dbStatus);
                const isSlaMinutesPending = timer < task.sla_minutes * 60;

                return (
                  <TableRow key={task.id} sx={{ '&:hover': { bgcolor: '#f8fafc' } }}>
                    <TableCell sx={{ color: "#1e293b", fontWeight: 500 }}>{task.job_name}</TableCell>
                    <TableCell sx={{ color: "#475569" }}>{task.sla_minutes} min</TableCell>
                    <TableCell sx={{ color: statusColor, fontWeight: "bold" }}>{displayStatus}</TableCell>

                    <TableCell>
                      {dbStatus === "new" && (
                        <Button size="small" variant="contained"
                          onClick={() => startTaskById(task.id)}
                          disabled={isAnyJobRunning}
                          sx={{ bgcolor: "#1976d2", color: "#fff", fontWeight: "bold" }}>
                          Start
                        </Button>
                      )}

                      {dbStatus === "in_progress" && (
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <Button size="small" variant="contained" color="success"
                            onClick={() => handleCompleteClick(task.id)}
                            disabled={isSlaMinutesPending}
                            sx={{ fontWeight: "bold" }}>
                            Complete
                          </Button>
                          <Button size="small" variant="contained" color="warning"
                            onClick={() => holdTaskById(task.id)}
                            sx={{ fontWeight: "bold" }}>
                            Hold
                          </Button>
                        </Box>
                      )}

                      {dbStatus === "hold" && (
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <Button size="small" variant="contained" color="primary"
                            onClick={() => resumeTaskById(task.id)}
                            disabled={isAnyJobRunning}
                            sx={{ fontWeight: "bold" }}>
                            Resume
                          </Button>
                          <Button size="small" variant="contained" color="success" disabled>
                            Complete
                          </Button>
                        </Box>
                      )}

                      {dbStatus === "completed" && (
                        <Typography sx={{ color: "#2e7d32", fontWeight: "bold" }}>Done</Typography>
                      )}

                      {dbStatus === "cancelled" && (
                        <Typography sx={{ color: "#d32f2f", fontWeight: "bold" }}>Cancelled</Typography>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>

          <TablePagination
            component="div"
            count={pagination.total}
            page={pagination.current_page - 1}
            rowsPerPage={pagination.per_page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 20, 50]}
            sx={{
              ...PaginationFieldSx,
              color: "#1e293b",
              ".MuiTablePagination-actions": { color: "#1976d2" }
            }}
          />
        </Box>
      </Card>

      {/* ── Photo modal ── */}
      <Dialog open={photoModalOpen} onClose={closePhotoModal} maxWidth="md" fullWidth>

        <DialogTitle sx={{ color: "#1e293b", fontWeight: "bold" }}>
          Upload / Capture Photos
          <IconButton onClick={closePhotoModal} sx={{ position: "absolute", right: 8, top: 8, color: "#64748b" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ bgcolor: "#fff" }}>
          {!cameraOpen ? (
            <>
              <Alert severity="info" sx={{ mb: 2, bgcolor: "#f0f9ff", color: "#0369a1", border: "1px solid #bae6fd" }}>
                • Minimum {MIN_PHOTOS} photo required to complete task<br />
                • Maximum {MAX_PHOTOS} photos allowed (Gallery + Camera combined)<br />
                • Photos will be uploaded only when you click "Complete Task"
              </Alert>
              <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
                <Button
                  variant="outlined"
                  component="label"
                  startIcon={<PhotoLibraryIcon />}
                  disabled={photos.length >= MAX_PHOTOS}
                  sx={{ textTransform: "none", fontWeight: "bold" }}
                >
                  Upload from Gallery (Max {MAX_PHOTOS})
                  <input type="file" accept="image/*" multiple hidden
                    onChange={handleFileSelectWithSource} />
                </Button>
                <Button
                  variant="outlined"
                  onClick={openCamera}
                  startIcon={<CameraAltIcon />}
                  disabled={photos.length >= MAX_PHOTOS}
                  sx={{ textTransform: "none", fontWeight: "bold" }}
                >
                  Open Live Camera
                </Button>
              </Box>

              {photos.length > 0 && (
                <>
                  <Typography variant="subtitle2" sx={{ mt: 2, mb: 1, color: "#1e293b", fontWeight: "bold" }}>
                    Selected Photos ({photos.length}/{MAX_PHOTOS})
                  </Typography>
                  <Grid container spacing={2}>
                    {photos.map((photo, idx) => (
                      <Grid item xs={6} sm={4} md={3} key={idx}>
                        <Box sx={{ position: "relative", boxShadow: "0 4px 12px rgba(0,0,0,0.1)", borderRadius: 2, overflow: "hidden" }}>
                          <img src={photo.previewUrl} alt={`preview-${idx}`}
                            style={{ width: "100%", height: 120, objectFit: "cover", display: "block" }} />
                          <IconButton size="small" onClick={() => removePhoto(idx)}
                            sx={{ position: "absolute", top: 4, right: 4, bgcolor: "rgba(0,0,0,0.6)", '&:hover': { bgcolor: "rgba(0,0,0,0.8)" } }}>
                            <DeleteIcon fontSize="small" sx={{ color: "#fff" }} />
                          </IconButton>
                          {photo.source === "camera" && (
                            <Typography variant="caption" sx={{
                              position: "absolute", bottom: 4, left: 4,
                              bgcolor: "rgba(25,118,210,0.85)", color: "#fff", px: 1, borderRadius: 1, fontWeight: 500
                            }}>Camera</Typography>
                          )}
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </>
              )}
            </>
          ) : (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
              <video ref={videoRef} autoPlay playsInline style={{ width: "100%", maxWidth: 500, borderRadius: 8, border: "2px solid #1976d2" }} />
              <canvas ref={canvasRef} style={{ display: "none" }} />
              <Box sx={{ display: "flex", gap: 2 }}>
                <Button variant="contained" color="primary"
                  onClick={capturePhotoWithSource}
                  disabled={photos.length >= MAX_PHOTOS}
                  startIcon={<CapturePhotoIcon />} sx={{ fontWeight: "bold" }}>
                  Capture Photo
                </Button>
                <Button variant="outlined" color="error" onClick={closeCamera} sx={{ fontWeight: "bold" }}>
                  Close Camera
                </Button>
              </Box>
              <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>
                Captured: {photos.length} / Max {MAX_PHOTOS}
              </Typography>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ p: 2, bgcolor: "#f8fafc" }}>
          {!cameraOpen && (
            <Button onClick={submitPhotosAndComplete} variant="contained" color="success"
              disabled={isCompleteDisabled}
              sx={{ px: 4, fontWeight: "bold" }}>
              {completing ? "Uploading..." : `Complete Task (${photos.length} photo(s))`}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Jobs;